import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import { getBackendUserUrl } from 'utils/utils';

const AgendaDeleteConfirmationDialog = ({ open, onClose, onConfirm, agendaItem }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setIsDeleting(true);
    setError(null);
    
    try {
      const response = await fetch((getBackendUserUrl() + `/agenda/agenda_items/${agendaItem.agendaId}`), {
        method: 'DELETE',
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete agenda item');
      }

      // Call the parent's onConfirm with the deleted item's ID
      onConfirm(agendaItem.agendaId);
      onClose();
    } catch (error) {
      console.error('Error deleting agenda item:', error);
      setError('Failed to delete the agenda item. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Agenda Item</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete "{agendaItem?.name}"? This will delete all associated tasks. This action cannot be undone.
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleDelete} 
          color="error" 
          variant="contained"
          disabled={isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgendaDeleteConfirmationDialog; 